import Layout from "../Layouts/Index";
import React, {useState} from "react";
import CallToAction from "../Views/CallToAction";
import BenefitSection from "../Views/BenefitSection";
import HowItWorks from "../Views/HowItWorks";
import AppProcess from "../Views/AppProcess";
import HeroForCarOwners from "../Views/HeroForCarOwners";
import HeroForPassengers from "../Views/HeroForPassengers";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
    const settings = {
        dots: false,
        centerMode: true,
        centerPadding: '0',
        lazyLoad: true,
        // fade: true,
        infinite: true,
        speed: 400,
        slidesToScroll: 1,
        slidesPerRow: 1,
        slidesToShow: 1,
        autoplay: true,
        pauseOnHover: true,
        arrows: false,
        easing: 'easeInOutBounce',
    };
    return (
        <div data-aos="fade-right" className="bg-white w-full">
            <Slider {...settings}>
                <div className="w-full">
                    <HeroForCarOwners />
                </div>
                <div className="w-full">
                    <HeroForPassengers />
                </div>
            </Slider>
        </div>
    )
}

const Home = () => {
    const [showAppType, setShowAppType] = useState(false)

    return (
        <Layout>
            <Hero />
            <AppProcess
                appType={showAppType}
                setAppType={setShowAppType}
            />
            <HowItWorks
                appType={showAppType}
                setAppType={setShowAppType}
            />
            <CallToAction />
            <BenefitSection />
        </Layout>
    )
}

export default Home